export default __webpack_public_path__ + "static/media/bmw4.a720113d.png";